import { api } from "@/redux/api";

import {
	cohortParams,
	AdoptionResponseSchema,
	UnusedResponseSchema,
	CompaniesResponseSchema,
	CompanyResponseSchema,
	AllCustomersResponseSchema,
} from "./featureUsageSchema";

import type {
	ProductUsageAdoptionResponse,
	ProductUsageUnusedResponse,
	ProductUsageCompaniesResponse,
	ProductUsageCompanyResponse,
	ProductUsageAllCustomersResponse,
	ProductUsageFilters,
	ProductUsagePeriod,
	ProductUsageAllCustomersPeriod,
} from "@signalist/shared-types";

const base = "product-analytics/usage";
export const defaultUsageFilters: ProductUsageFilters = {
	period: 30,
	planId: null,
	includeTrialDemo: false,
	includeInternal: false,
};
export type CompanyUsageArgs = { companyId: number; period: ProductUsagePeriod };

export const featureUsageApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getFeatureUsageAdoption: builder.query<ProductUsageAdoptionResponse, ProductUsageFilters>({
			query: (filters) => ({
				url: `${base}/adoption`,
				params: cohortParams(filters),
				responseSchema: AdoptionResponseSchema,
			}),
			transformResponse: AdoptionResponseSchema.parse,
		}),
		getFeatureUsageUnused: builder.query<ProductUsageUnusedResponse, ProductUsageFilters>({
			query: (filters) => ({
				url: `${base}/unused`,
				params: cohortParams(filters),
				responseSchema: UnusedResponseSchema,
			}),
			transformResponse: UnusedResponseSchema.parse,
		}),
		getFeatureUsageCompanies: builder.query<ProductUsageCompaniesResponse, void>({
			query: () => ({ url: `${base}/companies`, responseSchema: CompaniesResponseSchema }),
			transformResponse: CompaniesResponseSchema.parse,
		}),
		getFeatureUsageCompany: builder.query<ProductUsageCompanyResponse, CompanyUsageArgs>({
			query: ({ companyId, period }) => ({
				url: `${base}/companies/${companyId}`,
				params: { period },
				responseSchema: CompanyResponseSchema,
			}),
			transformResponse: CompanyResponseSchema.parse,
		}),
		getFeatureUsageAllCustomers: builder.query<
			ProductUsageAllCustomersResponse,
			ProductUsageAllCustomersPeriod
		>({
			query: (period) => ({
				url: `${base}/all-customers`,
				params: { period },
				responseSchema: AllCustomersResponseSchema,
			}),
			transformResponse: AllCustomersResponseSchema.parse,
		}),
	}),
});
export const {
	useGetFeatureUsageAdoptionQuery,
	useGetFeatureUsageUnusedQuery,
	useGetFeatureUsageCompaniesQuery,
	useGetFeatureUsageCompanyQuery,
	useGetFeatureUsageAllCustomersQuery,
} = featureUsageApi;
